import { filePeview, ErrorResult } from '../shared/interfaces'

export interface rights {
  IsUser: boolean,
  IsAdmin:boolean
}

const win:any = window;
const rootUrl:string = win.__env.apipath;

const  blobToFile = (theBlob: Blob, fileName:string, type: string, lastModified:number): File => {
  let b: any = new Blob([theBlob],{ type: type});
  //A Blob() is almost a File() - it's just missing the two properties below which we will add
  b.name = fileName;
  b.lastModified=lastModified;
  //Cast to a File() type
  return b as File;
}

async function getFileFromPreview(preview: filePeview):Promise<File> {
  const f:File = await fetch(preview.preview)
    .then(r => r.blob())
    .then(blobFile => { 
      try
      {
        console.log("Converting Blob to file");
        return new File([blobFile], preview.name, { type: preview.type, lastModified:preview.lastModified }) ;
      }
      catch {
        // IE and Safari Work-Around!
        console.log("Its IE time");
        try {
          return blobToFile(blobFile, preview.name, preview.type, preview.lastModified);
        }
        catch (err)
        {
          console.log(err);
          throw err;
        }
      }
    });
  return f;
}

function SaveFile(blob:Blob, filename: string) {
  const nav: any = window.navigator;
  if (typeof nav.msSaveBlob !== 'undefined') {
    // IE workaround for "HTML7007: One or more blob URLs were 
    // revoked by closing the blob for which they were created. 
    // These URLs will no longer resolve as the data backing 
    // the URL has been freed."
    nav.msSaveBlob(blob, filename);
  }
  else {
      var blobURL = window.URL.createObjectURL(blob);
      var tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      tempLink.href = blobURL;
      tempLink.setAttribute('download', filename); 
      
      // Safari thinks _blank anchor are pop ups. We only want to set _blank
      // target if the browser does not support the HTML5 download attribute.
      // This allows you to download files in desktop safari if pop up blocking 
      // is enabled.
      if (typeof tempLink.download === 'undefined') {
          tempLink.setAttribute('target', '_blank');
      }
      
      document.body.appendChild(tempLink);
      tempLink.click();
      
      // Fixes "webkit blob resource error 1"
      setTimeout(function() {
          document.body.removeChild(tempLink);
          window.URL.revokeObjectURL(blobURL);
      }, 0)
  }
}

function appendData(preview: filePeview, fd: FormData)
{
  if (preview.userName !== undefined) {
    fd.append("user",preview.userName);
  }
  if (preview.email !== undefined) {
    fd.append("email",preview.email);
  }
  if (preview.tel !== undefined) {
    fd.append("tel",preview.tel);
  }
  if (preview.lang !== undefined) {
    fd.append("lang",preview.lang);
  }
}


export async function analyzeFile(preview: filePeview):Promise<ErrorResult|null> {
  const url = rootUrl + 'OVSC/Analyze';
  const fd:FormData = new FormData();
  const file:File = await getFileFromPreview(preview);
  appendData(preview,fd);
  fd.append(file.name,file);
  return fetch(url,{
    method: 'POST',
    cache: 'no-cache',
    mode:'cors',
    body: fd
  }).then( r => {
    if (r.status === 200)
    {
      return r.blob()
    } else if (r.status === 401)
    {
      return { No: -100, Mesage:"Unauthorized", AnalysisErrors:[]};
    } else
    {
      return r.json()
    }
  }).then(
    blob => {
      if (blob instanceof Blob) {
        SaveFile(blob,preview.name);
        return { No: 99999, Mesage:"signed", AnalysisErrors:[]};
      } else {
        return blob
      }
    }
  );
}

export async function analyzeAndSignFile(preview:filePeview):Promise<ErrorResult|null>  {
  const url = rootUrl + 'OVSC/AnalyzeAndSign';
  const fd:FormData = new FormData();
  const file:File = await getFileFromPreview(preview);
  appendData(preview,fd);
  fd.append(file.name,file);
  return fetch(url,{
    method: 'POST',
    cache: 'no-cache',
    mode:'cors',
    body: fd
  }).then( r => {
    if (r.status === 200)
    {
      return r.blob()
    } else if (r.status === 401)
    {
      return { No: -100, Mesage:"Unauthorized", AnalysisErrors:[]};
    } else
    {
      return r.json()
    }
  }).then(
    blob => {
      if (blob instanceof Blob) {
        SaveFile(blob,preview.name);
        return { No: 99999, Mesage:"signed", AnalysisErrors:[]};
      } else {
        return blob
      }
    }
  );
}